import * as React from "react"
import { type MetricValue } from "src/frontend/components/Shared/Layout/Components/Charts/toMetricSeries"
import { TileCardHeading } from "src/frontend/components/Shared/Layout/Components/Tiles/TileCard"

interface HeadingProps {
  className?: string
  metricSeries?: MetricValue[]
  selectedIndex?: number
}

export const MetricSeriesCardHeading: React.FC<HeadingProps> = ({
  className,
  metricSeries,
  selectedIndex,
}) => {
  const metricSeriesToDisplay =
    metricSeries && metricSeries[selectedIndex ?? metricSeries.length - 1]
  const noActivity = React.useMemo(
    () => metricSeries?.every((value) => value.value === 0),
    [metricSeries]
  )
  return (
    <TileCardHeading className={className} noActivity={noActivity}>
      {metricSeriesToDisplay && metricSeriesToDisplay.value}
    </TileCardHeading>
  )
}
